export default {
  name: 'Footer',
  data() {
    return {};
  },
  methods: {},
  created() {}
};